import { useEffect } from 'react';
import { auth } from '../utils/firebase'; 
import { onAuthStateChanged } from 'firebase/auth';
import { useAuthStore } from '../stores/useAuthStore';

export function useFirebaseAuth() {
  const setUser = useAuthStore((state) => state.setUser);

  useEffect(() => {
    // onAuthStateChanged returns an unsubscribe function
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
    });

    // Clean up the listener when the component unmounts
    return () => unsubscribe();
  }, [setUser]);
}